module.exports = __webpack_public_path__ + "img/fatal-error-1.1e66097c.png";